(() => {
  const normalize=(v='')=>v.toString().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLowerCase();
  const applyMenuIcons=()=>{
    const labels={'new merch':'New Merch 🔥','best sellers':'Best Sellers ⚡','bestsellers':'Best Sellers ⚡','inferiores':'Inferiores 👖','descuentos':'Descuentos 🔴'};
    document.querySelectorAll('#header-group a').forEach(link=>{
      const node=link.querySelector('.menu-list__link-title')||link;
      const raw=normalize(node.textContent).replace(/[🔥⚡👖🔴]/g,'').replace(/\s+/g,' ').trim();
      const rep=labels[raw]; if(!rep) return;
      if(node===link){
        const t=Array.from(link.childNodes).find(n=>n.nodeType===Node.TEXT_NODE&&n.textContent.trim());
        if(t)t.textContent=rep;
      } else node.textContent=rep;
    });
  };
  document.addEventListener('DOMContentLoaded',applyMenuIcons);
  document.addEventListener('shopify:section:load',applyMenuIcons);
})();